module.exports = __webpack_public_path__ + "img/speaker-rect-icon.c9685863.svg";